import bookingSystemAdvancedSteps from './bookingSystemAdvancedSteps'
import bookingSystemSetupSteps from './gettingStarted'
import paymentsAndDepositsSteps from './paymentsAndDepositsSteps'
import marketingToolsSteps from './marketingTools'
import gmbOnboardingSteps from './gmbOnboardingSteps'

const allSteps = [
  ...bookingSystemSetupSteps,
  ...bookingSystemAdvancedSteps,
  ...marketingToolsSteps,
  ...paymentsAndDepositsSteps,
  ...gmbOnboardingSteps,
]

export default allSteps